<script setup lang="ts">

const { point, header } = defineProps<{ point: string, header: string }>();

</script>

<template>
    <section class="flex legal-numbered-section px-4 lg:px-0">
        <div class="w-[30px] min-w-[30px] pt-[1.5px] font-semibold">{{ point }}</div>
        <div class="flex-grow">
            <h2 class="text-lg font-semibold">{{ header }}</h2>
            <slot />
        </div>
    </section>
</template>

<style lang="postcss">

.legal-numbered-section
{
    @apply my-6
}

.legal-numbered-section h2
{
    @apply mb-1
}

.legal-numbered-section p,
.legal-numbered-section ol
{
    @apply mb-3
}

.legal-numbered-section ol
{
    counter-reset: list;
}

.legal-numbered-section ol > li
{
    @apply mb-px flex;
}

.legal-numbered-section ol > li:before
{
    counter-increment: list;
    content: "(" counter(list, lower-alpha) ") ";
    @apply min-w-[40px];
}

</style>